"use client";

import { createContext, useContext } from "react";
import type { TenantBranding } from "@/app/api/utils/types/tenants";
import { EMPTY_LOCALIZED_TEXT, ALL_PAYMENT_METHOD_IDS } from "@/app/api/utils/types/tenants";

const FALLBACK: TenantBranding = {
  name: "",
  logoUrl: "",
  socialLinks: {},
  showEvents: true,
  showFlights: true,
  testMode: false,
  supportedCurrencies: null,
  banner: {
    imageUrl: "",
    title: { ...EMPTY_LOCALIZED_TEXT },
    description: { ...EMPTY_LOCALIZED_TEXT },
  },
  flightBanner: {
    imageUrl: "",
    title: { ...EMPTY_LOCALIZED_TEXT },
    description: { ...EMPTY_LOCALIZED_TEXT },
  },
  faqs: [],
  travelExperience: {
    heading: { ...EMPTY_LOCALIZED_TEXT },
    features: [],
  },
  customScripts: [],
  policies: {
    privacyPolicy: { ...EMPTY_LOCALIZED_TEXT },
    termsConditions: { ...EMPTY_LOCALIZED_TEXT },
  },
  footer: {
    text: { ...EMPTY_LOCALIZED_TEXT },
  },
  paymentMethods: [...ALL_PAYMENT_METHOD_IDS],
  contactPhone: "",
  contactEmail: "",
  faviconUrl: "",
  copyright: "",
  emptyStateImageUrl: "",
  primaryColor: "",
  secondaryColor: "",
};

const TenantBrandingContext = createContext<TenantBranding>(FALLBACK);

export function TenantBrandingProvider({
  children,
  branding,
}: {
  children: React.ReactNode;
  branding: TenantBranding;
}) {
  return (
    <TenantBrandingContext.Provider value={branding}>
      {children}
    </TenantBrandingContext.Provider>
  );
}

export function useTenantBranding() {
  return useContext(TenantBrandingContext);
}
